<!-- 疑虑&四重礼 -->
<template>
  <div class="doubt">
    <div class="solve">
      <h1 class="my-title">
        <div>
          <strong>{{ cardType === 'USLC' ? '美国手机' : '全球数据漫游' }}卡套餐到期了</strong>
          怎么办？
        </div>
        <img class="hidden-sm-and-up" src="@/assets/images/portin/doubt-QA.png" alt="" />
      </h1>
      <div class="content">
        <ul>
          <ol v-for="item in cardType === 'USLC' ? doubtList : doubtList2" :key="item.id">
            <div class="l" :style="{ '--w': cardType === 'USLC' ? '48px' : '86px' }">
              <span>{{ item.title }}</span>
            </div>
            <div class="r" v-html="item.content"></div>
          </ol>
        </ul>
        <div class="qa hidden-sm-and-down">
          <img src="@/assets/images/portin/doubt-QA.png" alt="" />
        </div>
      </div>
    </div>

    <!-- 更多优势 -->
    <Advantage :cardType="cardType" />

    <div class="reserve">
      <div class="content">
        <ul>
          <h1>活动细则</h1>
          <li>
            1.优惠详情：Visa中国持卡人在Visa中国权益平台购买专属ENC满减券，在活动页面购买活动产品即可立减；每个折扣码仅能享受1次优惠。
          </li>
          <li>2.可使用优惠的活动产品：美国手机卡套餐（除500mb套餐）; 全球漫游卡套餐。</li>
          <li>
            3.参与活动：
            <br />
            Step1: 用户通过Visa中国权益平台，购买Visa用户专享优惠券
            <br />
            Step2: 点击进入ENC Visa活动页，根据页面提示购买套餐，在优惠信息栏填写您的专属折扣码；
            <br />
            Step3: 等待物流寄送，支持中国、美国两地免费寄送
            <br />
            Step4: 使用前登入激活页面，激活您的手机卡
          </li>
          <li>
            <span>4.用户在Visa中国权益平台领取优惠券后,需在60天内进入活动页面使用，逾期作废</span>
          </li>

          <li class="check" @click="isMore = true" v-if="!isMore">
            <span>查看全部</span>
            <i class="el-icon-arrow-down"></i>
          </li>

          <template v-if="isMore">
            <li>5.所有优惠折扣码均为1次性，在ENC Mobile官网购买1次产品后即失效</li>
            <li>6.每位Visa中国持卡人每期活动限购1次优惠码，在ENC Mobile官网单次可购买多张卡。</li>
            <li>7.本活动优惠券不可兑换现金或获得退款，不能与其他优惠活动同时使用。</li>
            <li>
              8.领卡与寄送：ENC
              Mobile支持中国、美国两地免费寄送，下单成功后2-3个工作日内发货；手机卡/漫游卡寄出后，用户将会收到包含快递单号等信息的邮件通知。
            </li>
            <li>
              <span>
                9.激活方式：用户需进入官网激活页面
                <a href="https://www.encmobile.com/activation/first" target="_blank">
                  （https://www.encmobile.com/activation/first）
                </a>
                输入iccid以及激活码进行激活；为保证您落地就可以使用，建议您出发前1-2天进行激活。手机卡激活成功后套餐立即生效并开始计费；漫游卡完成激活流程后需要到达产品覆盖目的地后才能激活使用。
                激活成功后，您可以正常使用订购的服务，如您遇到激活失败的问题，用户可联系电话客服热线：美国：909-666-1188；中国：400-971-0982，国英粤三语热线7/24为您服务
              </span>
            </li>
            <li>
              10.套餐计费说明：手机卡漫游卡都需要在支付后的90天内激活。套餐有效期自激活之日起开始计算，为避免浪费，请在到达目的地前1-2天进行激活。套餐周期为30天，自套餐激活日起算，套餐有效期至激活日后的第30日，自第31日起当前套餐有效期届满，开始新套餐周期。
              所有套餐价格不包含由美国政府征收的并由用户承担的税费。
            </li>
            <li>
              11.为保证服务质量，用户在领卡页面填写个人邮箱时，默认接受提醒发货和激活的邮件通知；ENC
              Mobile会妥善保护用户的个人信息。
            </li>
            <li>
              12.为更好的服务用户，用户须填写真实、准确的个人资料。如因用户提供的个人资料不实或不准确而给用户自身造成了任何性质的损失，均由用户自行承担。
            </li>

            <li>
              13.ENC
              Mobile迎客移动有权对活动适时修改。本活动最终解释权归公司所有。本活动受美国加利福尼亚州法律及相关的联邦法律约束。
            </li>
            <li class="check" @click="isMore = false">
              <span>收起</span>
              <i class="el-icon-arrow-up"></i>
            </li>
          </template>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import Advantage from './Advantage.vue';

export default {
  components: {
    Advantage
  },
  props: {
    cardType: {
      type: String,
      default: 'USLC'
    }
  },
  data() {
    return {
      isMore: false,
      doubtList: [
        {
          id: 1,
          title: '续订套餐',
          content: `登录<span>个人中心</span>账户，续订1，3，6，12个月套餐，保持套餐持续续订状态。
              <br />
              若您已开启了套餐自动续订，则无需手动续订套餐哦。`
        },
        {
          id: 2,
          title: '变更套餐',
          content: `根据您这一段时间的流量使用情况，若初次购买的套餐无法满足您的需要，您可选择登录
              <span>个人中心</span>
              账户进行变更套餐。`
        }
      ],
      doubtList2: [
        {
          id: 1,
          title: '实体卡',
          content: `实体卡首次购买套餐使用完，可前往<span>个人中心</span>续订任意套餐，续订套餐数量不受限制，可叠加购买使用。`
        },
        {
          id: 2,
          title: 'eSIM卡',
          content: `eSIM手机卡暂不支持续订套餐，使用完重新购买即可。`
        }
      ],
      solveList: [
        {
          id: 1,
          title: '如果假期回国怎么办？',
          content:
            '不用担心昂贵的国际漫游费用，Wifi Calling功能让您的迎客美国手机卡在国内也能接收美国的电话、短信；您可开通保号服务，假期回国为你保留主套餐不扣费！'
        },
        {
          id: 2,
          title: '国内亲朋好友与我联系方便么',
          content:
            '非常方便，拥有迎客手机卡，您只需在官网开通一卡双号服务，国内亲朋好友拨打您的中国号即可，畅聊无阻。'
        },
        {
          id: 3,
          title: '可以携号转网么',
          content:
            '可以的，如果您是非迎客美国手机卡，可在活动页参与活动，激活时填写原运营商信息Pin code和Pin number即可保留原号码转入。'
        }
      ]
    };
  },
  methods: {
    handleJump() {
      const dom = document.querySelector('.package-info');
      if (dom) {
        dom.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
};
</script>
<style scoped lang="less">
@import './style/Doubt.less';
</style>
